import type { FaireProductEntity } from "../../entity_types/product";

export const p_bryjg59c5k: FaireProductEntity = {
  token: "p_bryjg59c5k",
  type: "product",
  name: "Disk Hoop Earrings | Silver",
  brandToken: "b_di01cyuf",
  brandName: "Lovoda",
  imageUrl:
    "https://cdn.faire.com/fastly/d3209d6273f766d9c2cd85361c8c0b7fad22f5cfc595443d05a39a5efdc0c0fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd11e6bb7310578746f264bb3c2d17e7336e78d5300b45d025a562b340634f33.jpeg",
    "https://cdn.faire.com/fastly/0971bbe02265248ea385c1d2bd136eefa385e00bb0f60666cc01356dcff4d83c.jpeg",
    "https://cdn.faire.com/fastly/569c360c0d1ef82d5104b7ba2727afbc0451b9e978b1c665e9aab06275bc0639.jpeg",
  ],
  priceDollars: 7.2,
  description:
    "Accessorize with the sleek gold disk-shaped hoop earrings.\n\n\n * Stainless Steel \n * 14k Gold Plating \nMeasurements:\n\n\n * ",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:32.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
